exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.info {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\n}\n.info .ant-row.ant-form-item {\r\n    width: 100%;\r\n    margin-right: 6px;\n}\n.ant-modal-footer button.ant-btn {\r\n    width: 75px !important;\n}\r\n", ""]);

// exports
